(function($) {

	'use strict';

	var init = function() {
		setupFilterListeners();
	};

    var setupFilterListeners = function() {

		$('.video-filter__item + input').on('change', function(e) {

			$(this).parents('form:first').submit();
			
		});
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);